<template>
    <div class="container" v-loading="loading">

        <div id="MAPRef" style="width: 100%;height: 100%;" />
		<div class="map_info">天地图 | 审图号：GS(2024)0568号 | <label @click="linkTo">湘ICP备2024068008号-1</label></div>

		<div class="search_box" v-if="search">
			<el-input v-model="keywords" style="width: 100%;" placeholder="搜索城市、景点" clearable
				@keyup.enter.native="handleEnter" @clear="searchClear" @focus="searchFocus">
				<i slot="prefix" class="el-input__icon el-icon-search"></i>
			</el-input>
			<div class="search_list" v-show="searchList.length && searchListShow">
				<div v-for="item in searchList" :key="item.id" class="search_item" @click="selectPoi(item)">
					<div class="item_label">
						<div class="name">{{ item.name }}</div>
						<div class="type">{{ item.typeName }}</div>
					</div>
					<div class="item_address">{{ item.address }}</div>
				</div>
			</div>
		</div>
    </div>
</template>
<script>
	import { getJson } from "@/utils/axios.js"
	import { cityList } from "@/utils/cityList"
    export default{
		props: {
			markers: {
				type: Array,
				default: []
			},
			search: {
				type: Boolean,
				default: true
			},
			mapType: {
				type: String,
				default: '卫星图'
			},
			markerMode: {
				type: Boolean,
				default: false
			},
			markerTheme: {
				type: String,
				default: '晴空蓝'
			}
		},
		watch: {
			mapType: {
				handler(value){
					this.randerTypeKey = value === '卫星图' ? 'img_w' : 'vec_w'
					this.mountedBaseMap()
				},
			},
			markerTheme: {
				handler(){
					this.updateMarkers()
				},
			},
			markerMode: {
				handler(){
					this.updateMarkers()
				},
			},
			markers: {
				handler(){
					this.$nextTick(() => {
						this.updateMarkers()
					})
				},
				deep: true,
				immediate: false
			},
		},
        data(){
            return{
                tdt_client_key: "d31ea8c8b73b25ec71206ebc27c0e389",
				immersiveIcon: require('@/static/icon/dic_local_point_v2.gif'),

				loading: true,
				keywords: '',
				searchList: [],
				searchListShow: false,
                
                mapRef: null,
                randerTypeKey: 'img_w',
				nowLocation: {
					latitude: 33.765432,
					longitude: 104.293175,
				},
				markerRefs: [],

				drawRefs: [],
				
				activeCity: { label: '全国', value: ''},
				cityOpitons: cityList
            }
        },
		computed: {
			isMobile() {
				return window.innerWidth < 768
			},
			markerIcon(){
				switch(this.markerTheme){
					case '晴空蓝': return require('@/static/icon/dic_local_point_v3.png');
					case '松烟绿': return require('@/static/icon/dic_local_point_g2.gif');
					case '焰心红': return require('@/static/icon/dic_local_point_g3.gif');
					default: return require('@/static/icon/dic_local_point_v3.png');
				}
			}
		},
        methods: {
			// 创建简单标记点
			createSimpleMarker(){
				this.markers.forEach( item => {
					const customIcon = L.icon({
						iconUrl: this.markerIcon,
						iconSize: [16, 16],
					});
					const markerRef = L.marker( item.location, { icon: customIcon } ).addTo(this.mapRef)
					markerRef.addEventListener('click', e => {
						this.$emit("check", item, e)
					})
					this.markerRefs.push(markerRef)
				})
			},
			// 创建详细标记点
			createImmersiveMarker(){
				this.markers.forEach( item => {
					const customIcon = L.icon({
						iconUrl: this.immersiveIcon,
						iconSize: [40, 40],
						iconAnchor: [20, 32],
						popupAnchor: [0, 0]
					});
					const markerRef = L.marker( item.location, { icon: customIcon } ).addTo(this.mapRef)

					markerRef.addEventListener('click', e => {
						this.$emit("check", item, e)
					})

					this.markerRefs.push(markerRef)

					let htmlContent =  `
						<div style="text-align:center;">
							<div style="font-size:13px;color: #208FF1;padding: 0 5px;">${item.name || '目标地点'}</div>
						</div>
					`
					// 为标记绑定弹出窗口作为标题
					markerRef.bindTooltip(htmlContent, { 
						permanent: true,
						direction: 'left',
						className: 'custom-tooltip',
						offset: [-10, -15]
					}).openTooltip();
				})
			},
			// 创建标记点
			updateMarkers(){
				// 清除上次绘制的标记
				if(this.markerRefs.length){
					this.markerRefs.forEach( item => {
						this.mapRef && this.mapRef.removeLayer && this.mapRef.removeLayer(item);
					})
				}
				const L = window.L
				if(!L || !L.marker || !this.mapRef) return

				if(this.markerMode){
					this.createImmersiveMarker()
					return
				}
				this.createSimpleMarker()
			},
			// 定位到某个点
			setMapView(lat, lng){
				this.mapRef && this.mapRef.setView([ lat, lng ], 16);
			},
			// 初始化视角
			setInitView(){
				let lng = this.nowLocation.longitude;
				let lat = this.nowLocation.latitude;
				this.mapRef.setView([lat, lng], this.isMobile ? 4 : 5);
			},

			// 备案号跳转
			linkTo(){
				window.open('https://beian.miit.gov.cn')
			},

			// 回车搜索
			handleEnter(){
				this.getPoiList(this.keywords)
			},
			// 清空搜索
			searchClear(){
				this.keywords = ''
				this.searchListShow = false
				this.searchList = []
			},
			// 搜索激活
			searchFocus(){
				if(!this.searchListShow && this.searchList.length){
					this.searchListShow = true
				}
			},
			// 选择搜索结果
			selectPoi(item){
				const locationArr = item.lonlat.split(',')
				this.updateLocationCenter([Number(locationArr[1]), Number(locationArr[0])])
				this.searchListShow = false
			},
			updateLocationCenter(centerPoint){
				if(!window.L) return
				this.mapRef && this.mapRef.setView(centerPoint, 15);
			},
			// 获取搜索结果
			async getPoiList(keywords){
				getJson('/location/poi', {
					keywords
				}, (res) => {
					const { data } = res
					this.searchList = data.pois || []
					this.searchListShow = true
					if(this.searchList.length <= 0){
						this.$message('没有查询到目标信息');
					}
				})
			},

			// 尝试获取用户位置信息
			getUserLocation() {
				if ('geolocation' in navigator) {
					navigator.geolocation.getCurrentPosition(
						(position) => {
							this.nowLocation = {
								latitude: position.coords.latitude,
								longitude: position.coords.longitude
							};
							this.mapRef && this.mapRef.setView([ Number(locationArr[1]), Number(locationArr[0]) ], 16);
						},(error) => {
							switch (error.code) {
							case error.PERMISSION_DENIED:
								console.log('您拒绝了位置请求。');
								break;
							case error.POSITION_UNAVAILABLE:
								console.log('位置信息不可用。');
								break;
							case error.TIMEOUT:
								console.log('请求位置信息超时。');
								break;
							case error.UNKNOWN_ERROR:
								console.log('发生未知错误。');
								break;
							}
						}
					)
				}else {
					console.log('您的浏览器不支持位置服务。');
				}
			},

            // 挂载地图底图
			mountedBaseMap() {
				this.$nextTick(() => {
					const L = window.L
					if (!L) return

					if (this.viewLayer && this.mapRef.hasLayer(this.viewLayer)) {
						this.mapRef.removeLayer(this.viewLayer);
						this.viewLayer = null;
					}

					let viewUrl = ''
					if (this.randerTypeKey == 'img_w') {
						viewUrl = "http://t4.tianditu.gov.cn/img_w/wmts?" +
							"SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
							"&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=" + this.tdt_client_key;
					} else {
						viewUrl = "http://t4.tianditu.gov.cn/vec_w/wmts?" +
							"SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
							"&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=" + this.tdt_client_key;
					}
					this.viewLayer = L.tileLayer(viewUrl, {
						maxNativeZoom: 18, // 超过图层最大值时的保持比例
						maxZoom: 22, // 允许缩放最大值
						preferCanvas: true,
						opacity: 1,
					}).addTo(this.mapRef);

					// 注记图层 默认添加
					const cvaURL = "http://t0.tianditu.gov.cn/cia_w/wmts?" +
						"SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
						"&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=" + this.tdt_client_key;
					this.cvaLayer = L.tileLayer(cvaURL, {
						maxNativeZoom: 18,
						maxZoom: 22,
						preferCanvas: true,
						opacity: 1,
					}).addTo(this.mapRef);
					
					this.loading = false
					
				})
			},
            // 地图初始化
			initTmap() {
				// this.loading = true
				const L = window.L
				let lng = this.nowLocation.longitude;
				let lat = this.nowLocation.latitude;
				this.mapRef = L.map( 'MAPRef', {
					zoomControl: false, // 显示缩放控件
					attributionControl: false, // 显示版权文字
					zoomAnimation: false, // 禁用缩放动画
					markerZoomAnimation: false, // 禁用标记的缩放动画
					minZoom: 3,
				}).setView([lat, lng], this.isMobile ? 4 : 5);
				this.mountedBaseMap()
				this.updateMarkers()
			},
        },
        mounted() {
			this.getUserLocation()
			if (typeof window.L == 'function') {
				this.initTmap();
			} else {
				// 创建leaflet库
				const leafletScript = document.createElement('script');
				leafletScript.src = `https://unpkg.com/leaflet@1.9.4/dist/leaflet.js`;
				document.body.appendChild(leafletScript);
				leafletScript.onload = this.initTmap.bind(this);
			}
		}
    }
</script>
<style lang="scss" scoped>
	:deep(.mobile-tooltip){
		background: rgba($color: #FFF, $alpha: 0.8);
	}
	:deep(.custom-tooltip) {
		background: rgba($color: #FFF, $alpha: 0.9);
	}
	.container{
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
		.search_box{
			position: absolute;
			left: 10px;top: 10px;
			z-index: 9249;
			width: 320px;
			.search_list{
				background-color: #FFF;
				margin-top: 5px;
				border-radius: 5px;
				max-height: 400px;
				overflow-y: auto;
			}
			.search_item{
				padding: 5px 10px;
				text-align: left;
				border-bottom: 1px solid #eee;
				cursor: pointer;
				.item_label{
					display: flex;
					justify-content: space-between;
					.name{
						font-size: 14px;
						padding-right: 10px;
					}
					.type{
						background-color: #B7CDF0;
						color: #FFF;
						padding: 0 10px;
						height: 24px;
						line-height: 24px;
						font-size: 13px;
						border-radius: 5px;
					}
				}
				.item_address{
					font-size: 13px;
					color: #666;
				}
			}
			.search_item:hover{
				.name{
					color: #0B57D0;
				}
				.item_address{
					color: #0B57D0;
				}
			}
			.city-box{
				position: absolute;
				right: -190px;top: 2px;
				display: flex;
				color: #FFF;
				padding: 7px 0;
				width: 180px;
				text-align: left;
			}
		}
	}
	@media (max-width: 767px) {
		.container{
			width: 100%;
			height: 100%;
			position: relative;
			overflow: hidden;
			.search_box{
				position: absolute;
				left: 10px;top: 10px;
				z-index: 9249;
				width: calc( 100% - 20px );
				.search_list{
					background-color: #FFF;
					margin-top: 5px;
					border-radius: 5px;
					max-height: 400px;
					overflow-y: auto;
				}
				.search_item{
					padding: 5px 10px;
					text-align: left;
					border-bottom: 1px solid #eee;
					cursor: pointer;
					.item_label{
						display: flex;
						justify-content: space-between;
						.name{
							font-size: 14px;
							padding-right: 10px;
						}
						.type{
							background-color: #B7CDF0;
							color: #FFF;
							padding: 0 10px;
							height: 24px;
							line-height: 24px;
							font-size: 13px;
							border-radius: 5px;
						}
					}
					.item_address{
						font-size: 13px;
						color: #666;
					}
				}
				.search_item:hover{
					.name{
						color: #0B57D0;
					}
					.item_address{
						color: #0B57D0;
					}
				}
			}
		}
	}

	.map_info{
		position: absolute;
		left: 0;bottom: 0;
		z-index: 924;
		width: 400px;
		background: rgba($color: #FFFFFF, $alpha: 0.8);
		font-size: 12px;
		padding: 6px 0;
		border-radius:  0 5px 0 0;
		text-align: center;
	}
	.map_info label{
		cursor: pointer;
	}
	.map_info label:hover{
		color: #0B57D0;
	}
	@media (max-width: 767px) {
		.map_info {
			width: 100%;
			border-radius: 0;
		}
	}
</style>